export default {
  // 深耕于人事场景和分销场景数据
  HrAndDistributionList: [
    {
      title: '人事场景痛点',
      tabList: ['员工信息收集及建档难', '分子公司异地签约效率低', '员工签约进度难追踪', '员工信息和薪资不能泄露'],
      planTitle: '人事场景解决方案',
      planDesc: '基于人事场景提供如下能力，助力企业人事场景入转\n调离高效流转',
      planListOne: ['员工信息收集表搭建', '薪资信息保密', '合同批量发签', '合同到期提醒'],
      planListTwo: ['人事合同自定义台账', '人事信息与EHR系统互连', '人事档案管理等能力'],
      scenarioTitle: '覆盖人事几大场景',
      scenarioImgs: [
        {
          key: 1,
          img: require('../../assets/images/smart-contract/renshi-one.png'),
          text: 'offer发放',
        },
        {
          key: 2,
          img: require('../../assets/images/smart-contract/renshi-two.png'),
          text: '员工信息收集',
        },
        {
          key: 3,
          img: require('../../assets/images/smart-contract/renshi-three.png'),
          text: '劳动合同签订&续签',
        },
        {
          key: 4,
          img: require('../../assets/images/smart-contract/renshi-four.png'),
          text: '转岗调岗协议签订',
        },
        {
          key: 5,
          img: require('../../assets/images/smart-contract/renshi-five.png'),
          text: '内部证明开具',
        },
        {
          key: 6,
          img: require('../../assets/images/smart-contract/renshi-six.png'),
          text: '数据同步EHR系统建档',
        },
      ],
    },
    {
      title: '分销场景痛点',
      tabList: [
        '经销商遍布全国各地\n异地签约效率低',
        '合同经常变更\n解约麻烦',
        '合同是履约的重要凭证\n履约信息获取难',
        '经销商资质经常变更\n风险难管控',
      ],
      planTitle: '分销场景解决方案',
      planDesc: '基于分销场景为企业提供如下能力，助力企业分销场\n景跨系统高效签管，体现合同全链路价值',
      planListOne: ['经销商风控管理', '经销合同内容审批', '智能比对', '经销合同自动分类归档'],
      planListTwo: ['经销合同自定义台账', '分子公司管理', '数据同步业务系统'],
      scenarioTitle: '覆盖分销几大场景',
      scenarioImgs: [
        {
          key: 1,
          img: require('../../assets/images/smart-contract/fenxiao-one.png'),
          text: '经销商风险审查',
        },
        {
          key: 2,
          img: require('../../assets/images/smart-contract/fenxiao-two.png'),
          text: '经销商合作协议签订',
        },
        {
          key: 3,
          img: require('../../assets/images/smart-contract/fenxiao-three.png'),
          text: '物流单对账单签订',
        },
        {
          key: 4,
          img: require('../../assets/images/smart-contract/fenxiao-four.png'),
          text: '业务履约信息提取',
        },
        {
          key: 5,
          img: require('../../assets/images/smart-contract/fenxiao-five.png'),
          text: '业务数据跟进',
        },
        {
          key: 6,
          img: require('../../assets/images/smart-contract/fenxiao-six.png'),
          text: '业务数据同步业务系统履约',
        },
      ],
    },
  ],

  // 穿透合同生命周期的智能化管理方案数据
  ContractLifeCycleList: [
    {
      key: 1,
      img: require('../../assets/images/smart-contract/cycle-one.png'),
      text: '智能拟定',
    },
    {
      key: 2,
      img: require('../../assets/images/smart-contract/cycle-two.png'),
      text: '相对方\n智能审查',
    },
    {
      key: 3,
      img: require('../../assets/images/smart-contract/cycle-three.png'),
      text: '智能签署',
    },
    {
      key: 4,
      img: require('../../assets/images/smart-contract/cycle-four.png'),
      text: '智能比对',
    },
    {
      key: 5,
      img: require('../../assets/images/smart-contract/cycle-five.png'),
      text: '智能审批',
    },
    {
      key: 6,
      img: require('../../assets/images/smart-contract/cycle-six.png'),
      text: '智能归档',
    },
    {
      key: 7,
      img: require('../../assets/images/smart-contract/cycle-seven.png'),
      text: '智能台账',
    },
    {
      key: 8,
      img: require('../../assets/images/smart-contract/cycle-eight.png'),
      text: '数据同步\n业务系统履约',
    },
  ],

  // 客户成功案例数据
  CustomerCaseList: {
    orgTypeList: ['人力资源', '地产租房', '互联网+', '银行金融', '零售制造', '汽车物流', '教育旅游', '公共服务'],
    imgs: ['humanRes', 'logistics', 'hlw', 'bank', 'lszz', 'qqwl', 'jjly', 'ggfw'].map(item => {
      return require(`../../assets/images/${item}.png`)
    }),
  },
}
